import React from 'react'
import {Box, Divider, Grid, Typography} from "@material-ui/core";
import get from 'lodash/get'
import style from './authenticationcontainer.module.css'
import Paper from "@material-ui/core/Paper";
import LTALogo from "../../assets/img/lta_logo.png";
function AuthenticationContainer(props){
    const content=get(props,"Component","")
    const titleLabel= get(props,"titleLabel","")
return (
    <Grid container className={style.authentication_container_wrapper} direction={"column"}>
        <Grid item className={style.authentication_container_wrapper}>
            <Typography className={style.authentication_container_title_label}>{titleLabel}</Typography>
        </Grid>
        <Grid item>
            <Divider className={style.authentication_container_top_line} />
            <Grid container component={Paper}  elevation={4}  className={style.authentication_container_content_wrapper}>
                <Grid item className={style.authentication_container_content_item}>
                    {content}
                </Grid>

                <Box paddingBottom={"15px"}/>
                <Grid item className={style.authentication_container_logo}>
                    <img src={LTALogo} width={"164"} height={"32"}/>
                </Grid>
            </Grid>
        </Grid>
    </Grid>
)
}

export default AuthenticationContainer